<template>
  <div class="no-count-container">
    <div class="no-count-content">
      <div class="title-content">
        <span class="iconfont icontanhao"></span>
        <span>AI 智能简历生成次数已达上限</span>
      </div>
      <div class="desc">当前功能为测试版，免费次数已用完</div>
      <div class="btn-content">
        <div class="btn" @click="handleBtnClick('more')">查看更多模版</div>
        <div class="btn" @click="handleBtnClick('know')">我知道了</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "NoCountModal",
  methods: {
    handleBtnClick(type) {
      if (type === "more") {
        this.$emit("more");
      } else {
        this.$emit("know");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.no-count-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 39;
  .no-count-content {
    padding: 40px;
    border-radius: 16px;
    background: #424957;
    width: 520px;
    height: 248px;
    box-sizing: border-box;
    .title-content {
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 20px;
      font-weight: 500;
      line-height: normal;
      .iconfont {
        color: #ffbd5c;
        font-size: 20px;
        margin-right: 16px;
      }
    }
    .desc {
      color: #fff;
      font-size: 16px;
      font-weight: 400;
      line-height: normal;
      margin-top: 24px;
    }
    .btn-content {
      display: flex;
      width: 100%;
      .btn {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 54px;
        border-radius: 100px;
        border: 1px solid #fff;
        margin-top: 40px;
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        &:last-child {
          margin-left: 20px;
          background: linear-gradient(90deg, #ffbe5d 0%, #f64 100%);
          color: #1c212a;
          border: none;
        }
      }
    }
  }
}
</style>
